import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { ROUTES } from 'config/constants';

const UnauthRoute = ({ component: Component, isAuthenticated, ...rest }) => {
  window.initializedAppcues.then((appcues) => {
    try {
      appcues.anonymous();
    } catch (error) {
      console.error('APPCUES INITIALIZATION FAILED');
      console.error(error);
    }
  });

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Redirect to={ROUTES.HOME_PAGE} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

UnauthRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ authState }) => ({
  isAuthenticated: !!authState.isAuth,
});

export default connect(mapStateToProps)(UnauthRoute);
